import { DevSignInForm } from './DevSignInForm.js';
import { nextAfterSignIn } from './nextAfterSignIn.js';
import { signInError } from './signInError.js';
import { useAuthMode } from './useSession.js';

/** Henry opts a browser in once with `localStorage.setItem('altSignIn', '1')`; nobody else is shown the link. */
function altSignInEnabled(): boolean {
  try {
    return window.localStorage.getItem('altSignIn') === '1';
  } catch {
    return false;
  }
}

export function SignIn(): React.JSX.Element {
  const mode = useAuthMode();

  const reason = signInError('This app is for Project A.');
  // Google's callback has to know where sign-in was a detour from, because it
  // lands the browser itself rather than handing control back to this page.
  const next = nextAfterSignIn();
  const googleHref =
    next === null ? '/auth/google' : `/auth/google?next=${encodeURIComponent(next)}`;
  const altHref = `/auth/google/login?client=alt${next === null ? '' : `&next=${encodeURIComponent(next)}`}`;

  return (
    <div className="signin">
      <div className="signin-card">
        <h1>Follow-On Investors</h1>
        <p className="subtle">Project A's follow-on investor list.</p>
        {reason !== undefined && <p className="signin-error">{reason}</p>}

        <a className="button primary" href={googleHref}>
          Sign in with Google
        </a>
        {mode.data?.googleAlt === true && altSignInEnabled() && (
          <a className="subtle" href={altHref}>
            Sign in with an external Google account
          </a>
        )}
        {mode.data?.google === false && (
          <p className="subtle">Google sign-in is not configured on this server yet.</p>
        )}

        {mode.data?.devLogin === true && <DevSignInForm placeholder="you@project-a.vc" />}
      </div>
    </div>
  );
}
